'use strict'
import request from '@/utils/request'
// import qs from 'qs'

const model = {
  tree (base) {
    return request({
      url: '/gallery/tree',
      method: 'get',
      params: {base}
    })
  },
  search (keyword) {
    return request({
      url: `/gallery/search/${encodeURIComponent(keyword)}`,
      method: 'get'
    })
  },
  upload (file) {
    const formData = new FormData()
    formData.append('file', file)
    return request({
      url: `/gallery/upload`,
      method: 'post',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      timeout: 300000
    })
  }
}

export default model



// WEBPACK FOOTER //
// ./src/api/gallery.js